/**
 * API server root url ...
 *
 * @type {string}
 */

export const API_ROOT_URL = '/api';

/**
 * Blog ...
 */

export const API_BLOG_POST_LIST = `${API_ROOT_URL}/blog/posts/list`;
export const API_BLOG_POST_FILTER_DATA = `${API_ROOT_URL}/blog/posts/filter-data`;
export const API_BLOG_POST_DETAILS = `${API_ROOT_URL}/blog/posts/details/`;
export const API_BLOG_POST_DETAILS_BY_SLUG = `${API_ROOT_URL}/blog/posts/details-slug/`;


/**
 * Post Attachment ...
 */


export const API_BLOG_POST_ATTACHMENT_VIEW = `/api/blog/attachments/view/`;
export const API_BLOG_POST_ATTACHMENT_DOWNLOAD = `/api/blog/attachments/download/`;



export const SUBMISSIONS_ROOT = `${API_ROOT_URL}/submissions`;

/**
 * Business Insurance form submission endpoint ...
 *
 * @type {string}
 */

export const API_BUSINESS_INSURANCE_QUOTE_NEW = `${API_ROOT_URL}/quotes/business-insurance/new`;
export const API_BUSINESS_INSURANCE_QUOTE_DETAILS = `${API_ROOT_URL}/quotes/business-insurance/details/`;
export const API_BUSINESS_INSURANCE_QUOTE_UPDATE = `${API_ROOT_URL}/quotes/business-insurance/update/`;
export const API_BUSINESS_INSURANCE_QUOTE_TRASH = `${API_ROOT_URL}/quotes/business-insurance/trash/`;
export const API_BUSINESS_INSURANCE_QUOTE_PURGE = `${API_ROOT_URL}/quotes/business-insurance/purge/`;
export const API_BUSINESS_INSURANCE_QUOTE_RESTORE = `${API_ROOT_URL}/quotes/business-insurance/restore/`;
export const API_BUSINESS_INSURANCE_QUOTE_LIST = `${API_ROOT_URL}/quotes/business-insurance/list`;


/**
 * Car Insurance form submission endpoint ...
 *
 * @type {string}
 */

export const API_CAR_INSURANCE_QUOTE_NEW = `${API_ROOT_URL}/quotes/car-insurance/new`;
export const API_CAR_INSURANCE_QUOTE_DETAILS = `${API_ROOT_URL}/quotes/car-insurance/details/`;
export const API_CAR_INSURANCE_QUOTE_UPDATE = `${API_ROOT_URL}/quotes/car-insurance/update/`;
export const API_CAR_INSURANCE_QUOTE_TRASH = `${API_ROOT_URL}/quotes/car-insurance/trash/`;
export const API_CAR_INSURANCE_QUOTE_PURGE = `${API_ROOT_URL}/quotes/car-insurance/purge/`;
export const API_CAR_INSURANCE_QUOTE_RESTORE = `${API_ROOT_URL}/quotes/car-insurance/restore/`;
export const API_CAR_INSURANCE_QUOTE_LIST = `${API_ROOT_URL}/quotes/car-insurance/list`;

/**
 * Van Insurance form submission endpoint ...
 *
 * @type {string}
 */

export const API_VAN_INSURANCE_QUOTE_NEW = `${API_ROOT_URL}/quotes/van-insurance/new`;
export const API_VAN_INSURANCE_QUOTE_DETAILS = `${API_ROOT_URL}/quotes/van-insurance/details/`;
export const API_VAN_INSURANCE_QUOTE_UPDATE = `${API_ROOT_URL}/quotes/van-insurance/update/`;
export const API_VAN_INSURANCE_QUOTE_TRASH = `${API_ROOT_URL}/quotes/van-insurance/trash/`;
export const API_VAN_INSURANCE_QUOTE_PURGE = `${API_ROOT_URL}/quotes/van-insurance/purge/`;
export const API_VAN_INSURANCE_QUOTE_RESTORE = `${API_ROOT_URL}/quotes/van-insurance/restore/`;
export const API_VAN_INSURANCE_QUOTE_LIST = `${API_ROOT_URL}/quotes/van-insurance/list`;

/**
 * Taxi Insurance form submission endpoint ...
 *
 * @type {string}
 */

export const API_TAXI_INSURANCE_QUOTE_NEW = `${API_ROOT_URL}/quotes/taxi-insurance/new`;
export const API_TAXI_INSURANCE_QUOTE_DETAILS = `${API_ROOT_URL}/quotes/taxi-insurance/details/`;
export const API_TAXI_INSURANCE_QUOTE_UPDATE = `${API_ROOT_URL}/quotes/taxi-insurance/update/`;
export const API_TAXI_INSURANCE_QUOTE_TRASH = `${API_ROOT_URL}/quotes/taxi-insurance/trash/`;
export const API_TAXI_INSURANCE_QUOTE_PURGE = `${API_ROOT_URL}/quotes/taxi-insurance/purge/`;
export const API_TAXI_INSURANCE_QUOTE_RESTORE = `${API_ROOT_URL}/quotes/taxi-insurance/restore/`;
export const API_TAXI_INSURANCE_QUOTE_LIST = `${API_ROOT_URL}/quotes/taxi-insurance/list`;

/**
 * Motor cycle Insurance form submission endpoint ...
 *
 * @type {string}
 */

export const API_MOTOR_CYCLE_INSURANCE_QUOTE_NEW = `${API_ROOT_URL}/quotes/motor-cycle-insurance/new`;
export const API_MOTOR_CYCLE_INSURANCE_QUOTE_DETAILS = `${API_ROOT_URL}/quotes/motor-cycle-insurance/details/`;
export const API_MOTOR_CYCLE_INSURANCE_QUOTE_UPDATE = `${API_ROOT_URL}/quotes/motor-cycle-insurance/update/`;
export const API_MOTOR_CYCLE_INSURANCE_QUOTE_TRASH = `${API_ROOT_URL}/quotes/motor-cycle-insurance/trash/`;
export const API_MOTOR_CYCLE_INSURANCE_QUOTE_PURGE = `${API_ROOT_URL}/quotes/motor-cycle-insurance/purge/`;
export const API_MOTOR_CYCLE_INSURANCE_QUOTE_RESTORE = `${API_ROOT_URL}/quotes/motor-cycle-insurance/restore/`;
export const API_MOTOR_CYCLE_INSURANCE_QUOTE_LIST = `${API_ROOT_URL}/quotes/motor-cycle-insurance/list`;


/**
 * Employer Liability Insurance form submission endpoint ...
 *
 * @type {string}
 */

export const API_EMPLOYER_LIABILITY_INSURANCE_QUOTE_NEW = `${API_ROOT_URL}/quotes/employer-liability-insurance/new`;
export const API_EMPLOYER_LIABILITY_INSURANCE_QUOTE_DETAILS = `${API_ROOT_URL}/quotes/employer-liability-insurance/details/`;
export const API_EMPLOYER_LIABILITY_INSURANCE_QUOTE_UPDATE = `${API_ROOT_URL}/quotes/employer-liability-insurance/update/`;
export const API_EMPLOYER_LIABILITY_INSURANCE_QUOTE_TRASH = `${API_ROOT_URL}/quotes/employer-liability-insurance/trash/`;
export const API_EMPLOYER_LIABILITY_INSURANCE_QUOTE_PURGE = `${API_ROOT_URL}/quotes/employer-liability-insurance/purge/`;
export const API_EMPLOYER_LIABILITY_INSURANCE_QUOTE_RESTORE = `${API_ROOT_URL}/quotes/employer-liability-insurance/restore/`;
export const API_EMPLOYER_LIABILITY_INSURANCE_QUOTE_LIST = `${API_ROOT_URL}/quotes/employer-liability-insurance/list`;


/**
 * Fast food delivery Insurance form submission endpoint ...
 *
 * @type {string}
 */

export const API_FAST_FOOD_DELIVERY_INSURANCE_QUOTE_NEW = `${API_ROOT_URL}/quotes/fast-food-delivery-insurance/new`;
export const API_FAST_FOOD_DELIVERY_INSURANCE_QUOTE_DETAILS = `${API_ROOT_URL}/quotes/fast-food-delivery-insurance/details/`;
export const API_FAST_FOOD_DELIVERY_INSURANCE_QUOTE_UPDATE = `${API_ROOT_URL}/quotes/fast-food-delivery-insurance/update/`;
export const API_FAST_FOOD_DELIVERY_INSURANCE_QUOTE_TRASH = `${API_ROOT_URL}/quotes/fast-food-delivery-insurance/trash/`;
export const API_FAST_FOOD_DELIVERY_INSURANCE_QUOTE_PURGE = `${API_ROOT_URL}/quotes/fast-food-delivery-insurance/purge/`;
export const API_FAST_FOOD_DELIVERY_INSURANCE_QUOTE_RESTORE = `${API_ROOT_URL}/quotes/fast-food-delivery-insurance/restore/`;
export const API_FAST_FOOD_DELIVERY_INSURANCE_QUOTE_LIST = `${API_ROOT_URL}/quotes/fast-food-delivery-insurance/list`;

/**
 * Home Insurance form submission endpoint ...
 *
 * @type {string}
 */

export const API_HOME_INSURANCE_QUOTE_NEW = `${API_ROOT_URL}/quotes/home-insurance/new`;
export const API_HOME_INSURANCE_QUOTE_DETAILS = `${API_ROOT_URL}/quotes/home-insurance/details/`;
export const API_HOME_INSURANCE_QUOTE_UPDATE = `${API_ROOT_URL}/quotes/home-insurance/update/`;
export const API_HOME_INSURANCE_QUOTE_TRASH = `${API_ROOT_URL}/quotes/home-insurance/trash/`;
export const API_HOME_INSURANCE_QUOTE_PURGE = `${API_ROOT_URL}/quotes/home-insurance/purge/`;
export const API_HOME_INSURANCE_QUOTE_RESTORE = `${API_ROOT_URL}/quotes/home-insurance/restore/`;
export const API_HOME_INSURANCE_QUOTE_LIST = `${API_ROOT_URL}/quotes/home-insurance/list`;

/**
 * Accident management claim form submission endpoint ...
 *
 * @type {string}
 */

export const API_ACCIDENT_MANAGEMENT_CLAIM_NEW = `${API_ROOT_URL}/claims/accident-management/new`;
export const API_ACCIDENT_MANAGEMENT_CLAIM_DETAILS = `${API_ROOT_URL}/claims/accident-management/details/`;
export const API_ACCIDENT_MANAGEMENT_CLAIM_UPDATE = `${API_ROOT_URL}/claims/accident-management/update/`;
export const API_ACCIDENT_MANAGEMENT_CLAIM_TRASH = `${API_ROOT_URL}/claims/accident-management/trash/`;
export const API_ACCIDENT_MANAGEMENT_CLAIM_PURGE = `${API_ROOT_URL}/claims/accident-management/purge/`;
export const API_ACCIDENT_MANAGEMENT_CLAIM_RESTORE = `${API_ROOT_URL}/claims/accident-management/restore/`;
export const API_ACCIDENT_MANAGEMENT_CLAIM_LIST = `${API_ROOT_URL}/claims/accident-management/list`;
